var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQueueManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.228,
    y: 11.0449,
    width: 17.6311,
    height: 9.33413,
    rx: 1,
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.834 24.5273V32.5634M12.1621 64.9936V37.0188C12.1621 34.8097 13.953 33.0188 16.1621 33.0188H37.231",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4248 41.0898V65.9808M54.6847 65.9808V41.0898",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3533 41.0902V22.3477C59.3533 21.2431 58.4579 20.3477 57.3533 20.3477H44.2407C43.1362 20.3477 42.2407 21.2431 42.2407 22.3477V41.0902",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0811 16.055C52.9618 16.055 54.4865 14.5303 54.4865 12.6495C54.4865 10.7688 52.9618 9.24414 51.0811 9.24414C49.2003 9.24414 47.6757 10.7688 47.6757 12.6495C47.6757 14.5303 49.2003 16.055 51.0811 16.055Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQueueManagement);
export default __webpack_public_path__ + "static/media/icon-queue-management.2e2e8749b05e87d74d79c1c91b31e449.svg";
export { ForwardRef as ReactComponent };